import { __extends, __decorate, __metadata } from 'tslib';
import { Input, HostBinding, HostListener, Component, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, forwardRef, ViewChild, ViewContainerRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UkGroupComponent, UkChildItemComponent, UIKitCommonModule } from '@uikit/components/common';

var UkTabsGroupsComponent = /** @class */ (function (_super) {
    __extends(UkTabsGroupsComponent, _super);
    function UkTabsGroupsComponent(cdr) {
        var _this = _super.call(this, 'tabs-group', cdr) || this;
        _this.desktopBehaviour = 'tabs';
        _this.mobileBehaviour = 'accordion';
        _this.align = 'center';
        // TODO: Change default to normal
        _this.type = 'full';
        // this should be on a global varible
        _this.mobileWidth = 768;
        _this._isDesktop = false;
        return _this;
    }
    Object.defineProperty(UkTabsGroupsComponent.prototype, "hostClasses", {
        get: function () {
            return ['uk-tab-group', this.type, this.behaviour].join(' ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkTabsGroupsComponent.prototype, "isDesktop", {
        get: function () { return this._isDesktop; },
        set: function (value) {
            this._isDesktop = value;
            this.behaviour = this.isDesktop ? this.desktopBehaviour : this.mobileBehaviour;
        },
        enumerable: true,
        configurable: true
    });
    // Listen for window resize to change Tab behaviour
    UkTabsGroupsComponent.prototype.onResize = function (event) {
        this.isDesktop = this.mobileWidth <= event.target.innerWidth;
    };
    UkTabsGroupsComponent.prototype.ngOnInit = function () { this.isDesktop = this.mobileWidth <= window.innerWidth; };
    UkTabsGroupsComponent.prototype.proccessItems = function (list) {
        _super.prototype.proccessItems.call(this, list);
        if (this.behaviour === 'tabs') {
            // Selects current index
            this.selectIndex(this.selectedIndex, false);
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkTabsGroupsComponent.prototype, "desktopBehaviour", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkTabsGroupsComponent.prototype, "mobileBehaviour", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkTabsGroupsComponent.prototype, "align", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkTabsGroupsComponent.prototype, "type", void 0);
    __decorate([
        HostBinding('class'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], UkTabsGroupsComponent.prototype, "hostClasses", null);
    __decorate([
        HostListener('window:resize', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UkTabsGroupsComponent.prototype, "onResize", null);
    UkTabsGroupsComponent = __decorate([
        Component({
            selector: 'uk-tabs-group',
            template: "<ul class=\"uk-nav uk-tab-header uk-text-{{align}}\" role=\"tablist\">\r\n  <ng-container *ngFor=\"let tab of _items; let i = index\" >\r\n    <li class=\"uk-nav-item uk-tab-nav\"\r\n      role=\"tab\"\r\n      [attr.id]=\"tab.id + '-label'\"\r\n      [attr.aria-selected]=\"tab.active\"\r\n      [attr.aria-controls]=\"tab.id\"\r\n      [attr.tabindex]=\"tab.active ? 0 : -1\"\r\n      [ngClass]=\"{'active' : tab.active, 'selected' : selectedIndex === tab.index}\"\r\n      [ukAutofocus]=\"selectedIndex === tab.index\"\r\n      (click)=\"select(tab, true, behaviour === 'accordion')\"\r\n      (keydown)=\"keyNavigation($event)\">\r\n      {{tab.textLabel}}\r\n    </li>\r\n    <uk-tab-body\r\n      *ngIf=\"behaviour === 'accordion'\"\r\n      [ngClass]=\"{'active' : tab.active, 'selected' : tab.selected}\"\r\n      [attr.id]=\"tab.id\"\r\n      [attr.aria-labelledby]=\"tab.id + '-label'\"\r\n      [attr.aria-hidden]=\"!tab.active\"\r\n      [tab]=\"tab\">\r\n    </uk-tab-body>\r\n  </ng-container>\r\n</ul>\r\n<div class=\"uk-tabs-body\" *ngIf=\"behaviour === 'tabs'\">\r\n  <uk-tab-body\r\n    *ngFor=\"let tab of _items; let i = index\"\r\n    [ngClass]=\"{'active' : tab.active, 'selected' : selectedIndex === tab.index}\"\r\n    [attr.id]=\"tab.id\"\r\n    [attr.aria-labelledby]=\"tab.id + '-label'\"\r\n    [attr.aria-hidden]=\"!tab.active\"\r\n    [tab]=\"tab\">\r\n  </uk-tab-body>\r\n</div>\r\n",
            encapsulation: ViewEncapsulation.None,
            changeDetection: ChangeDetectionStrategy.OnPush
        }),
        __metadata("design:paramtypes", [ChangeDetectorRef])
    ], UkTabsGroupsComponent);
    return UkTabsGroupsComponent;
}(UkGroupComponent));

var UkTabComponent = /** @class */ (function (_super) {
    __extends(UkTabComponent, _super);
    function UkTabComponent() {
        return _super.call(this, 'tab') || this;
    }
    UkTabComponent_1 = UkTabComponent;
    var UkTabComponent_1;
    UkTabComponent = UkTabComponent_1 = __decorate([
        Component({
            selector: 'uk-tab',
            template: "\r\n<ng-template><ng-content></ng-content></ng-template>",
            encapsulation: ViewEncapsulation.None,
            changeDetection: ChangeDetectionStrategy.OnPush,
            providers: [{
                    provide: UkChildItemComponent,
                    useExisting: forwardRef(function () { return UkTabComponent_1; })
                }]
        }),
        __metadata("design:paramtypes", [])
    ], UkTabComponent);
    return UkTabComponent;
}(UkChildItemComponent));

var UkTabBodyComponent = /** @class */ (function () {
    function UkTabBodyComponent() {
    }
    UkTabBodyComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.tab.active) {
            this.templateContent.createEmbeddedView(this.tab.content);
        }
        this.suscription = this.tab.activeChange.subscribe(function (active) {
            if (active) {
                _this.templateContent.createEmbeddedView(_this.tab.content);
            }
            else {
                _this.templateContent.clear();
            }
        });
    };
    UkTabBodyComponent.prototype.ngOnDestroy = function () { this.suscription.unsubscribe(); };
    __decorate([
        Input(),
        __metadata("design:type", UkTabComponent)
    ], UkTabBodyComponent.prototype, "tab", void 0);
    __decorate([
        ViewChild('templateContent', { read: ViewContainerRef, static: true }),
        __metadata("design:type", ViewContainerRef)
    ], UkTabBodyComponent.prototype, "templateContent", void 0);
    UkTabBodyComponent = __decorate([
        Component({
            selector: 'uk-tab-body',
            template: "<ng-template #templateContent></ng-template>",
            encapsulation: ViewEncapsulation.None,
            changeDetection: ChangeDetectionStrategy.OnPush,
            host: {
                'role': 'tabpanel',
                'class': 'uk-tab-body'
            }
        }),
        __metadata("design:paramtypes", [])
    ], UkTabBodyComponent);
    return UkTabBodyComponent;
}());

var UIKitTabsModule = /** @class */ (function () {
    function UIKitTabsModule() {
    }
    UIKitTabsModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                UIKitCommonModule
            ],
            declarations: [
                UkTabsGroupsComponent,
                UkTabComponent,
                UkTabBodyComponent,
            ],
            exports: [
                UkTabsGroupsComponent,
                UkTabComponent
            ]
        })
    ], UIKitTabsModule);
    return UIKitTabsModule;
}());

export { UIKitTabsModule, UkTabsGroupsComponent as ɵa, UkTabComponent as ɵb, UkTabBodyComponent as ɵc };
//# sourceMappingURL=uikit-components-uk-tabs.js.map
